import React, { ButtonHTMLAttributes, forwardRef } from 'react'
import { BaseIconButton, BaseIconButtonProps } from './BaseIconButton'

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  Omit<BaseIconButtonProps, 'children'> & {
    'data-test-id'?: string
  }

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(
    {
      icon,
      variant,
      size,
      isActive,
      disabled,
      'data-test-id': dataTestId,
      onClick,
      className,
      style,
      iconClassname,
      iconSize,
      iconStyle,
      type,
      disableFocus,
      borderRadius,
      ...otherProps
    },
    ref
  ) {
    return (
      <BaseIconButton
        className={className}
        style={style}
        disabled={disabled}
        disableFocus={disableFocus}
        isActive={isActive}
        size={size}
        variant={variant}
        icon={icon}
        iconSize={iconSize}
        iconStyle={iconStyle}
        iconClassname={iconClassname}
        borderRadius={borderRadius}
      >
        {({ className: baseClassName, style: baseStyle, children }) => (
          <button
            ref={ref}
            type={type}
            onClick={onClick}
            className={baseClassName}
            style={baseStyle}
            disabled={disabled}
            data-test-id={dataTestId}
            {...otherProps}
          >
            {children}
          </button>
        )}
      </BaseIconButton>
    )
  }
)
